import { Suspense, useEffect } from "react";
import { useSearchParams } from "react-router";
import { useMenuDrawerContext } from "../../../../components/menu/MenuDrawerContextProvider.shared";
import { SpinnerLegacy } from "../../../../components";
import { useDeliveryPreferencesStore } from "./deliveryPreferencesStore";
import { stepRegistry } from "./stepRegistry";
import { BusinessUserAccessGuard } from "../guards/BusinessUserAccessGuard";
import { useEvents } from "../../../../hooks";
import { getSellarWebsiteUtms } from "../../../../utils/utmHelper";

export const DeliveryPreferencesFlow = () => {
  const [searchParams] = useSearchParams();
  const token = searchParams.get("token");
  const currentStep = useDeliveryPreferencesStore((s) => s.currentStep);
  const reset = useDeliveryPreferencesStore((s) => s.reset);
  const { setDisplayTypeOverride } = useMenuDrawerContext();
  const { track } = useEvents();
  useEffect(() => {
    setDisplayTypeOverride("hidden");
    return () => setDisplayTypeOverride(undefined);
  }, [setDisplayTypeOverride]);

  useEffect(() => {
    track("Delivery Preferences Flow Viewed", { ...getSellarWebsiteUtms() });
  }, [track]);

  useEffect(() => {
    reset();
  }, [token, reset]);

  const stepConfig = stepRegistry.find((s) => s.key === currentStep);

  if (!stepConfig) return null;

  const StepComponent = stepConfig.component;

  const skipUserCheck = currentStep !== "deliveryTime";

  return (
    <BusinessUserAccessGuard token={token} skipUserCheck={skipUserCheck}>
      <div>
        <Suspense
          fallback={
            <div className="flex justify-center py-20">
              <SpinnerLegacy />
            </div>
          }
        >
          <StepComponent />
        </Suspense>
      </div>
    </BusinessUserAccessGuard>
  );
};
